module.exports = __webpack_public_path__ + "static/media/affection-bride-bride-and-groom-2253842.e5a8fb52.jpg";